import React from 'react';
import { injectIntl, WrappedComponentProps } from 'react-intl';

import { WifiBand } from '@/domains/wifi';
import { translations } from '@/locale';

import Select, { Props as SelectProps } from '@/components/Select';
import { withValidation } from '@/components/hoc/withValidation';

export interface Props extends Omit<SelectProps<WifiBand>, 'items'>, WrappedComponentProps {}

const wifiBandSelect: React.FC<Props> = ({ intl, ...rest }) => {
  const items = Object.values(WifiBand).map((band) => ({
    value: band,
    name: intl.formatMessage({ id: translations.wifiBand.list[band] })
  }));

  return <Select {...rest} items={items} />;
};

const Default = injectIntl(wifiBandSelect);
export const wifiBandSelectWithValidation = withValidation(Default);
export default Default;
